// extracted by mini-css-extract-plugin
export default {"shadow":"aJOgvt","sticked":"bJOgvt","hidden":"cJOgvt","positionTop":"dJOgvt","positionBottom":"eJOgvt","positionXleft":"fJOgvt","positionXcenter":"gJOgvt","positionXright":"hJOgvt"};